import Experience from './Experience/Experience.js'

const experience = new Experience(document.querySelector('div.webgl'));